import Strings from '../../Strings';

// Display parts for one SmartMeter line item: the SKU a fulfillment attempt
// sent to the vendor next to the order item it was sent for.
export function smartmeterLineItemParts(item) {
  const orderedItem = [item.device_model, item.variant_label].filter(Boolean).join(' ');
  const ordered = item.ordered_sku ? `${orderedItem} (${item.ordered_sku})` : orderedItem;
  return {
    sku: item.sku,
    name: item.sku_description || item.sku,
    quantity: item.quantity,
    overrideNote: item.overridden ? Strings.formatString(Strings.shipping.smartmeterSkuOverride, ordered) : null,
  };
}

// One text line per item (plus the override note on its own line) for the
// pre-line cells of the shipment details table.
export function formatSmartmeterLineItems(items) {
  return (items || [])
    .map(item => {
      const parts = smartmeterLineItemParts(item);
      const name = parts.name !== parts.sku ? ` - ${parts.name}` : '';
      const line = `${parts.sku}${name} x${parts.quantity}`;
      return parts.overrideNote ? `${line}\n${parts.overrideNote}` : line;
    })
    .join('\n');
}
